import React from "react";
import find from "lodash/find";
import ReactDatePicker from "react-datepicker";
import { User, Calendar, X } from "react-feather";
import Modal from "react-modal";
import ModalContent from "../../common/Modal/ModalContent";
import close_modal from "../../assets/ic_close_wh.svg";
import { Button } from "../../common/Button/Button";
import moment from "moment";

export default function ConfirmationModalSmall(props) {
  return (
    <Modal
      isOpen={props.isOpen}
      onRequestClose={props.toggleModal}
      ariaHideApp={false}
    >
      <ModalContent className="general-modal">
      <div className="modal-header">
					<span className="modal-title">Confirm</span>
					<img
						alt="close"
						id="Close"
						src={close_modal}
						className="close modal-close"
						onClick={props.toggleModal}
					/>
				</div>
        <div className="modal-body notes-trail-content conv-pl25 conv-pr25 custom-scrollbar">
          <div className="conv-mt10">{props.message}</div>
          <div className="conv-mt10">
            <button 
                type="button" 
                className={`my-services-model-submit-btn conv-pl25 conv-pr25 conv-mt10`}
                onClick={() =>props.onPositive()}>
                {props.buttonText === undefined ? "OK" : props.buttonText}
            </button>
            <button 
                type="button" 
                className={`my-services-model-cancel-btn conv-ml25 conv-mt10`}
                onClick={() =>props.toggleModal()}>
                Cancel
            </button>
          </div>
        </div>
      </ModalContent>
    </Modal>
  );
}
